import { Colors } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import fileOwner from '@/components/file/owner'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderTitle(h) {
  return h(
    textOverflow,
    {
      props: {
        value: this.value.title || this.value.filename
      }
    }
  )
}

function renderTag(h, { label, tooltip, color }) {
  return h(
    tag,
    {
      props: {
        label,
        tooltip,
        size: sizes.small,
        color: color || Colors.black
      }
    }
  )
}
function renderTags(h) {
  return h(
    'div',
    {
      class: 'file__info-tags'
    },
    [
      this.tags.map(item => {
        return renderTag.call(this, h, item)
      }),
      h(fileOwner, { props: { value: this.value } })
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'file__info'
    },
    [
      renderTitle.call(this, h),
      renderTags.call(this, h)
    ]
  )
}
